export default __webpack_public_path__ + "static/media/coresanscr75-webfont.f875668d.woff";